'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var exclamationMark = require('./exclamation-mark-02f43bf2.js');
var fieldLabel = require('./field-label-4ed9b7f8.js');
var messages = require('./messages-f8f39369.js');
var field_styles = require('./field.styles-a36bbd7b.js');

var useClickHandler = function (handleClick, disabled) { return React.useCallback(function (event) {
    if (!disabled && handleClick) {
        handleClick(event);
    }
}, [handleClick, disabled]); };
var Field = function (_a) {
    var value = _a.value, placeholder = _a.placeholder, _b = _a.variant, variant = _b === void 0 ? 'normal' : _b, Icon = _a.Icon, label = _a.label, required = _a.required, disabled = _a.disabled, handleClick = _a.onClick, rightText = _a.rightText, errorText = _a.errorText, readOnly = _a.readOnly, divProps = tslib_es6.__rest(_a, ["value", "placeholder", "variant", "Icon", "label", "required", "disabled", "onClick", "rightText", "errorText", "readOnly"]);
    var handleFieldClick = useClickHandler(handleClick, disabled);
    return (React__default.createElement(fieldLabel.FieldLabel, { label: label, required: required, readOnly: readOnly },
        React__default.createElement(field_styles.FieldStyled, tslib_es6.__assign({ isPlaceholderShown: !value, variant: variant, onClick: handleFieldClick, disabled: disabled, readOnly: readOnly }, divProps),
            React__default.createElement(field_styles.Label, null, value !== null && value !== void 0 ? value : placeholder,
                readOnly && value && rightText && " " + rightText),
            !readOnly && rightText && React__default.createElement(field_styles.RightText, null, rightText),
            !readOnly && React__default.createElement(Icon, { className: "field-icon", size: "sm" }),
            errorText && (React__default.createElement(field_styles.ExclamationMarkContainer, null,
                React__default.createElement(exclamationMark.ExclamationMark, { variant: "pink", size: "none", width: 20, height: 20 })))),
        React__default.createElement(messages.Messages, { errorText: errorText })));
};

exports.Field = Field;
